module.exports = __webpack_public_path__ + "static/___004___10-miniutes-from-the-beach.6dd3a9b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider/___004___10-miniutes-from-the-beach.jpg
// module id = 1280
// module chunks = 64098118039141